import { getAppDataHash } from './utils/appDataHash'

export const APP_DATA_HASH = getAppDataHash()
